import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: '[appButton]',
  template: '<ng-content></ng-content>',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonComponent {
  @HostBinding('class') get class(): { [key: string]: boolean } {
    return {
      [`variant-${this.variant}`]: true,
    };
  }

  @Input() variant: 'primary' | 'link' | 'warning' = 'primary';
}
